import _ from 'lodash';

import { ILevelGeneralData, levelGeneralData } from 'src/app/infrastructure/models/level-general-data';
import { IUserForm } from './user-form';
import { IUserDto, userDto } from 'src/assets/common/models/user-dto.g';
import { IImageBoxData, ImageBoxData } from '../../image/models/image-box-data';
import { IImageParentData, imageParentData } from '../../image/models/image-parent-data';
import { imageBoxDto } from 'src/assets/common/models/image-box-dto.g';
import { imageDto } from 'src/assets/common/models/image-dto.g';

export interface IUserCache {
    data: IUserData;
    url: string;
}

export const userData = {
    ... levelGeneralData,
    ... imageParentData,
    
    guid: 'guid',
    applicationName: 'applicationName',
    firstName: 'firstName',
    lastName: 'lastName',
    correspondenceName: 'correspondenceName',
    email: 'email',
    deleted: 'deleted',
    inactive: 'inactive',
} as const;

export type TUserData = (typeof userData)[keyof typeof userData];

export interface IUserData extends ILevelGeneralData, IImageParentData {
    [userData.guid]: string;
    [userData.applicationName]: string | null;
    [userData.firstName]: string | null;
    [userData.lastName]: string | null;
    [userData.correspondenceName]: string | null;
    [userData.email]: string | null;
    [userData.deleted]: boolean;
    [userData.inactive]: boolean;
    
    [userData.photoThumbGuid]: string | null;
    [userData.photoOriginGuid]: string | null;
    [userData.photoVersion]: string | null;
}

export class UserData 
    implements IUserData
{
    [userData.guid]!: string;
    [userData.applicationName]: string | null = null;
    [userData.firstName]: string | null = null;
    [userData.lastName]: string | null = null;
    [userData.correspondenceName]: string | null = null;
    [userData.email]: string | null = null;
    [userData.deleted]!: boolean;
    [userData.inactive]!: boolean;
    
    [userData.photoThumbGuid]: string | null = null;
    [userData.photoOriginGuid]: string | null = null;
    [userData.photoVersion]: string | null = null;

    protected constructor(modelDto?: IUserDto | null);
    protected constructor(modelData: IUserData, modelForm: IUserForm);
    protected constructor(value?: IUserDto | IUserData | null, modelForm?: IUserForm) {
        if (!!modelForm) {
            const _modelData = value as IUserData;
            _.assign(this, _modelData, modelForm);
        } else if (!!value) {
            const _modelDto = value as IUserDto;
            this[userData.guid] = _modelDto[userDto.guid]!;
            this[userData.applicationName] = _modelDto[userDto.applicationName];
            this[userData.firstName] = _modelDto[userDto.firstName];
            this[userData.lastName] = _modelDto[userDto.lastName];
            this[userData.correspondenceName] = _modelDto[userDto.correspondenceName];
            this[userData.email] = _modelDto[userDto.email];
            this[userData.deleted] = _modelDto[userDto.deleted]!;
            this[userData.inactive] = _modelDto[userDto.inactive]!;
            this[userData.photoThumbGuid] = _modelDto[userDto.photoBoxDto]?.[imageBoxDto.photoThumbDto]?.[imageDto.guid] ?? null;
            this[userData.photoOriginGuid] = _modelDto[userDto.photoBoxDto]?.[imageBoxDto.photoDto]?.[imageDto.guid] ?? null;
        }
    }
        
    static create(modelDto?: IUserDto | null): IUserData | null
    static create(modelData: IUserData, modelForm: IUserForm): IUserData | null
    static create(value?: IUserDto | IUserData | null, modelForm?: IUserForm): IUserData | null {

        if (!!modelForm) {
            const _modelData = value as IUserData;
            return new UserData(_modelData, modelForm);
        } else {
            const _modelDto = value as IUserDto;
            return _modelDto ? new UserData(_modelDto) : null;
        }
    }
}
